import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ target, label = "Prossimo Live", venue = "" }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!target) return null;
  const diff = new Date(target).getTime() - now.getTime();
  if (diff <= 0) return null;

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const cell = (v, l) => (
    <div className="flex flex-col items-center min-w-[52px] md:min-w-[70px]">
      <span className="font-display text-4xl md:text-6xl text-[color:var(--noise-green)] leading-none tabular-nums" style={{ textShadow: "0 0 12px rgba(57,255,20,0.35)" }}>
        {pad(v)}
      </span>
      <span className="text-white/50 uppercase text-[10px] md:text-xs tracking-widest mt-1">{l}</span>
    </div>
  );

  return (
    <div className="border border-[color:var(--noise-green)]/40 bg-black/60 backdrop-blur-sm p-4 md:p-5 inline-flex flex-col gap-3" data-testid="hero-countdown">
      <div className="flex items-center justify-between gap-4">
        <p className="uppercase text-[10px] md:text-xs tracking-[0.3em] text-white/60">{label}</p>
        {venue && <p className="text-white text-xs md:text-sm font-medium truncate max-w-[200px]">{venue}</p>}
      </div>
      <div className="flex items-end gap-3 md:gap-5">
        {cell(days, "Giorni")}
        <span className="font-display text-4xl md:text-6xl text-white/20 leading-none">:</span>
        {cell(hours, "Ore")}
        <span className="font-display text-4xl md:text-6xl text-white/20 leading-none">:</span>
        {cell(minutes, "Min")}
        <span className="font-display text-4xl md:text-6xl text-white/20 leading-none">:</span>
        {cell(seconds, "Sec")}
      </div>
    </div>
  );
};
